import { React, useState } from "react";
import { Form, Grid, GridColumn, Header, Segment, FormField, Button, Message, FormInput, Icon, Label } from "semantic-ui-react";
import { setLogin, setRegister, setSendResetToken } from "../queries";
import { useMutation } from "react-query";
import { useTranslation } from "react-i18next";
import { readFromToken, UserRoles } from "../auth.ts";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAppContext } from "../AppContext.jsx";

const LandingPage = () => {
  const { t } = useTranslation();

  const { updateToken, rtl } = useAppContext();

  const navigate = useNavigate();

  const [formMessage, setFormMessage] = useState(null);

  const setLoginMutation = useMutation(setLogin, {
    onSuccess: (response) => onLoginSuccess(response.data),
    onError: (error) => onLoginError(error)
  });

  const setSignupMutation = useMutation(setRegister, {
    onSuccess: (response) => onSignup(response),
  });

  const setResetPasswordMutiation = useMutation(setSendResetToken, {
    onSuccess: (response) => onResetPassword(response),
  });

  const onSignup = (response) => {
    switch(response.data){
      case "ok":
        setFormMessage({ success: true, header: t('signup-success'), content: t('signup-success-content') });
        break;
      case "user-exists":
        setFormMessage({ error:true, header: t('user-exists')});
        break
      case "invalid-data":
        setFormMessage({error:true, header: t('invaild-data-register')})
        break;
      case "invalid-email":
        setFormMessage({error:true, header: t('invalid-email')})
        break;
      case "invalid-course":
        setFormMessage({error:true, header: t('invalid-course')})
        break;
      case "invalid-password":
        setFormMessage({error:true, header: t('invalid-password')})
        break;


    }
  };


  const onLoginSuccess = (token) => {
    updateToken(token);

    const role = readFromToken('role');
    switch (role) {
      case UserRoles.AUTHORIZED_COMMANDER:
        navigate('/schedule');
        break;
      case UserRoles.AUTHORIZED_DOCTOR:
        navigate('/clinic/schedule');
        break;
      case UserRoles.UNAUTHORIZED_COMMANDER:
        setFormMessage({ error:true, header: t('unauthorized-user'), content: t('unauthorized-user-content') });
        break
      case UserRoles.UNAUTHORIZED_DOCTOR:
        setFormMessage({ error:true, header: t('unauthorized-admin'), content: t('unauthorized-admin-content') });
        break
    }
  }

  const onLoginError = (error) => {
    switch(error.response.data){
      case "unknown-user":
        setFormMessage({ error:true, header: t('unknown-user'), content: t('unknown-user-content') });
        break
      case "invalid-credentials":
        setFormMessage({ error:true, header: t('invalid-credentials')});
        break
      case "unauthorized-user":
        setFormMessage({ error:true, header: t('unauthorized-user'), content: t('unauthorized-user-content')});
        break
    }
  }

  const onResetPassword = (response) => {
    setSentResetEmail(true);
  }
  
  
  const onSubmitLogin = (e) => {
    e.preventDefault();
    const { email, password } = Object.fromEntries(new FormData(e?.target));
    setLoginMutation.mutate({ email, password });
  }

  const onSubmitSignup = (e) => {
    e.preventDefault();
    const { email, password, course, phone: phone_number } = Object.fromEntries(new FormData(e?.target));
    setSignupMutation.mutate({ email, password, course, phone_number });
  }

  const onSubmitResetPassword = (e) =>{
    e.preventDefault();
    const { email } = Object.fromEntries(new FormData(e?.target));
    setResetPasswordMutiation.mutate({ email });  }

  const switchFormType = (formType) => {
    setFormType(formType);
    setFormMessage(null);
    handleClear();
  }

  const [searchParams, setSearchParams] = useSearchParams();
  const [showSignupForm, setShowSignupForm] = useState(searchParams.get('form') === 'register');

  const [email,setEmail] = useState("");
  const [course,setCourse] = useState("");
  const [phone, setPhone] = useState("");
  const [password,setPassword] = useState("");

  const handleClear = () => {
    setEmail("");
    setCourse("");
    setPassword("");
    setPhone("");
    setSentResetEmail(false);
  }

  const [formType, setFormType] = useState(searchParams.get('form') === 'register'?"signup-form":"login-form")
  const [sentResetMail, setSentResetEmail] = useState(false);

  const renderForm = (formType) =>{


    switch(formType){
      case "signup-form":
        return (
          <Form onSubmit={(e) => onSubmitSignup(e)} loading={setLoginMutation.isLoading}>
            <Segment>
              <FormField style={{ marginBottom: 20 }}>
                <FormInput className="signup-form-input" name="email" value={email} type="text" placeholder={t('email')} onChange ={(_, { value }) => setEmail(value)} />
                <p className="signup-p" style={{ textAlign: rtl ? 'right' : 'left', color: "grey" }}><Icon name="info circle"/>{t('signup-email-desc')}</p>
              </FormField>
              <FormField style={{ marginBottom: 20 }}>
                <FormInput className="signup-form-input" name="phone" value={phone} type="text" placeholder={t('phone')} onChange ={(_, { value }) => setPhone(value)}/>
                <p className="signup-p" style={{ textAlign: rtl ? 'right' : 'left', color: "grey" }}><Icon name="info circle"/>{t('signup-phone-desc')}</p>
              </FormField>
              <FormField>
                <FormInput name="course" value={course} type="text" placeholder={t('course')} onChange ={(_, { value }) => setCourse(value)}/>
              </FormField>
              <FormField>
                <FormInput name="password" value={password} type="Password" placeholder={t('password')} onChange ={(_, { value }) => setPassword(value)}/>
              </FormField>
              <Button primary type='submit' size="large" fluid>{t('signup')}</Button>
            </Segment>
          </Form>        
        )
      case "login-form":
        return (
          <>
            <Form onSubmit={(e) => onSubmitLogin(e)} loading={setLoginMutation.isLoading}>
              <Segment>
                <FormField>
                  <FormInput name="email" value={email} type="text" placeholder={t('email')} onChange ={(_, { value }) => setEmail(value)}/>
                </FormField>
                <FormField>
                  <FormInput name="password" value={password} type="Password" placeholder={t('password')} onChange ={(_, { value }) => setPassword(value)}/>
                </FormField>
                <Button primary type='submit' size="large" fluid>{t("login")}</Button>
              </Segment>
            </Form>
            <Message attached='bottom' info>
              <Icon name='help' />
              {t("Forgot-Your-Password?")}&nbsp;<a onClick={() => switchFormType("forgot-password-form")}>{t("Reset-your-password")}</a>.
            </Message>
          </>
        )
      case "forgot-password-form":
        return (
          <>{!sentResetMail?(
            <Form onSubmit={(e) => onSubmitResetPassword(e)} loading={setResetPasswordMutiation.isLoading}>
            <Segment>
              <FormField>
                <FormInput name="email" value={email} type="text" placeholder={t('email')} onChange ={(_, { value }) => setEmail(value)}/>
              </FormField>
              <Button primary type='submit' size="large" fluid>{t("reset-password")}</Button>

            </Segment>
          </Form>):(
            <Message success>
              {t("mail-sent")}
            </Message>
          )
          }</>
        )
        default:
          return <></>
    }
  }


  return (
    <Grid container centered verticalAlign="middle" style={{ height: '100%' }}>
      <GridColumn textAlign="center" style={{ maxWidth: 450 }}>
        <Segment>
          <Header textAlign="center" as="h2" icon="user md" content={t('ramot-clinic')} style={{ justifySelf: 'center' }}/>
        </Segment>
        <Segment basic>
          {renderForm(formType)}
              
              {
                formMessage && <Message attached="bottom" {...formMessage}/>
              }
          </Segment>
        <Segment basic>
          <Button style={{ direction: 'ltr' }} as="a" primary onClick={() => switchFormType(formType === "signup-form" ? "login-form":"signup-form")}>{
            formType === "signup-form" ? t("have-an-account") : t("dont-have-an-account")
          }</Button>
        </Segment>
      </GridColumn>
    </Grid>
  );
};

export default LandingPage;
